export default __webpack_public_path__ + "static/media/promo_spatial_audio_billie_eilish__ltg83lkpcqq2_medium.20d6514b.jpg";